import React from 'react';
import { RinkLanes } from './RinkLanes';
const coverage = [{
  label: 'Every week',
  body: 'A Lesson Card with the whole class at a glance, in 30, 45 and 60-minute versions'
}, {
  label: 'Every circuit',
  body: 'The skill of the week in three versions, with reps, short cues, the most common error and its fix'
}, {
  label: 'Warm-up games',
  body: 'A game with a skating purpose to open every class, plus a bank of extra games in every volume'
}, {
  label: 'Mixed levels',
  body: 'Beginner, Developing and Advanced lanes — nobody waits by the boards, nobody gets bored'
}, {
  label: 'The season show',
  body: 'An 8-count group phrase every week that builds into your end-of-season number'
}, {
  label: 'Format',
  body: 'Landscape pages that read rinkside on a phone, or print and laminate for the boards'
}];
const steps = ['Warm-up game', '3-Lane Circuit', 'Finish & Show-off'];
export function ProductReveal() {
  return <section aria-labelledby="mechanism-heading" className="w-full border-y-4 border-amber bg-rink-mid" data-id="element-335" data-mp="1b1h4sallmjl7">
      <div className="max-w-5xl mx-auto px-5 py-16 sm:py-20 text-center" data-id="element-336" data-mp="1f1hkdykfp0tu">
        <p className="text-[11px] font-semibold uppercase tracking-[1.8px] text-amber" data-id="element-337" data-mp="1jsr7arellq21">
          The mechanism
        </p>
        <h2 id="mechanism-heading" className="mt-3 font-display font-bold text-white text-3xl sm:text-5xl" data-id="element-338" data-mp="1orawr1sehjz5">
          The 3-Lane Lesson
        </h2>
        <p className="mx-auto mt-5 max-w-2xl text-base sm:text-lg text-white/75" data-id="element-339" data-mp="w358i5251cuk">
          One skill, taught three ways, in three lanes at the same time.{' '}
          <span className="font-semibold text-white" data-id="element-340" data-mp="114uirihjdmhl">
            One sheet of ice, three levels, zero splitting.
          </span>{' '}
          You circulate instead of dividing the class — and every lesson runs in
          the same three steps.
        </p>

        <div className="mx-auto mt-8 max-w-2xl rounded-2xl bg-rink-deep p-4 sm:p-6" data-id="element-341" data-mp="2hfq73b0l7e45">
          <RinkLanes data-id="element-342" data-mp="1rs2t9pnvr45o" />
          <div className="mt-3 flex flex-wrap justify-center gap-x-5 gap-y-1.5 text-[11px] font-semibold uppercase tracking-widest text-white/70" data-id="element-343" data-mp="1rrayui60rcgz">
            <span data-id="element-344" data-mp="21qs44yhczocf"><span className="text-mint" data-id="element-345" data-mp="21qs3cw9jbkbd">L1</span> Beginner · door side</span>
            <span data-id="element-346" data-mp="21opewgo15z8r"><span className="text-amber" data-id="element-347" data-mp="1wrz1k13m1hr1">L2</span> Developing · center</span>
            <span data-id="element-348" data-mp="1wsqo6mf8c556"><span className="text-coral-soft" data-id="element-349" data-mp="1wpvzujt3i06h">L3</span> Advanced · far boards</span>
          </div>
        </div>

        <ol className="mx-auto mt-8 flex max-w-3xl flex-wrap items-center justify-center gap-2 sm:gap-3" data-id="element-350" data-mp="1901suivgj5u5">
          {steps.map((step, i) => <li key={step} className="flex items-center gap-2 sm:gap-3" data-id="element-351" data-mp="1it924etbj5zi" data-mpi={i}>
              <span className="rounded-full bg-amber/15 px-4 py-2 text-[13px] font-semibold text-amber-hover" data-id="element-352" data-mp="1e0xs2j4v63t8">
                <span className="mr-1.5 font-display font-bold" data-id="element-353" data-mp="qb3hk880orc5">{i + 1}.</span>
                {step}
              </span>
              {i < steps.length - 1 && <span className="hidden h-px w-5 bg-amber/50 sm:block" data-id="element-354" data-mp="laz6wytsiqtu" />}
            </li>)}
        </ol>

        <ul className="mt-9 grid gap-2.5 text-left sm:grid-cols-2 lg:grid-cols-3" data-id="element-355" data-mp="31rdn1l56cq0w">
          {coverage.map(item => <li key={item.label} className="rounded-card border border-rink-line bg-white/5 px-4 py-3" data-id="element-356" data-mp="2n3aimg6s5me7">
              <span className="block text-[11px] font-semibold uppercase tracking-widest text-amber" data-id="element-357" data-mp="2rypyfdoclsd9">
                {item.label}
              </span>
              <span className="mt-1 block text-sm text-white/85" data-id="element-358" data-mp="3koey9npbnmda">
                {item.body}
              </span>
            </li>)}
        </ul>
      </div>
    </section>;
}